export const LevelThree = {
    props: ['ar3Item'],
    template: `
        <a class="header-nav-main-unit-body-section-segment-body-unit" :class="ar3Item['class']" :href="ar3Item['href']">
             <span v-html="ar3Item['text']"></span>
             <span class="header-nav-main-unit-body-section-segment-body-unit-comment"></span>
        </a>
    `
}